import Modal from "./Modal"
import { CardVariant } from "../../models/CardVariant"
import { Link } from "react-router-dom";
import { ReactNode } from "react";
import { Bars3BottomLeftIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { classNames } from "../../style/common";
import { ModernCardImage } from "../CardVariantImage/ModernCardImage";
import { SpinnerAnimation } from "../Spinner/Spinner";

export type CardPreviewModalProps = {
    variant: CardVariant | undefined,
    isOpen: boolean,
    showSearchTargetButton: boolean,
    onOpenChange: (isOpen: boolean) => void,
    onShowSearchTargetsClick: (variant: CardVariant | undefined) => void,
    isSearchTargetLoading: boolean,
    actions?: ReactNode
}

export function CardPreviewModal(props: CardPreviewModalProps) {
    if (!props.variant) {
        return <></>;
    }

    return <>
        <Modal
            isOpen={props.isOpen}
            ignoreNavbarDodge={true}
            onOpenChange={(newIsOpen) => props.onOpenChange(newIsOpen)}
            classNames={{
                dialogPanel: "!p-0 !bg-transparent rounded-xl !shadow-none",
                modalTransitionContainer: "!max-w-[350px] absolute left-0 lg:left-72 right-0 mx-auto items-center",
                mainContainer: "!mt-0"
            }}
        >
            <ModernCardImage
                rounded="xl"
                cardName={props.variant.card?.name}
                imagePath={props.variant.imageId}
                serial={props.variant.serial} />

            <div className="flex justify-end gap-2 mt-2 select-none">
                {
                    props.showSearchTargetButton && props.variant.card.isSearcher &&
                    <div
                        className={classNames(CARD_PREVIEW_BUTTON_STYLE, "flex-1 cursor-pointer")}
                        onClick={() => props.onShowSearchTargetsClick(props.variant)}
                        title="Show Search Targets"
                    >
                        {
                            props.isSearchTargetLoading
                                ? <SpinnerAnimation />
                                : <MagnifyingGlassIcon className="h-8 w-8" />
                        }
                    </div>
                }
                <Link className={classNames(CARD_PREVIEW_BUTTON_STYLE, "flex-1")} to={`/cards/${props.variant.serial}`} target="_blank" title="Card Details">
                    <Bars3BottomLeftIcon className="h-8 w-8" />
                </Link>
                {
                    props.actions &&
                    props.actions
                }
            </div>
        </Modal>
    </>
}

export const CARD_PREVIEW_ELEMENT_STYLE = "flex items-center text-center justify-center theme-dark text-contrast-primary bg-primary rounded-md p-2 border border-color-border/50"
export const CARD_PREVIEW_BUTTON_STYLE = `${CARD_PREVIEW_ELEMENT_STYLE} hover:bg-secondary disabled:bg-muted disabled:cursor-not-allowed`;

export type CardPreviewModalState = {
    isOpen: boolean,
    variant: CardVariant | undefined
}